import React, { Component } from 'react';
import { Grid, Image } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import axios from 'axios';
import Swipe from 'react-easy-swipe';
import { Map } from 'immutable';
import ReduxToastr from 'react-redux-toastr';
import { connect } from 'react-redux';
import {
  getMessages,
  getActiveQuickReply,
  isBotTyping,
  activeGifSelector,
} from '../../redux';
import operations from '../../redux/operations';
import QuickReplyBanner from './QuickReplyBanner';
import ChatHistory from './ChatHistory';
import config from '../../config/directline';
import '../../App.css';
import UserInput from './UserInput';
import { getUserId, getIpAddress } from '../../redux';
import bnp_horizontal_logo from '../../img/intro/bnp_horizontal_logo.png';
import home_middle_bg from '../../img/intro/home-middle-bg.png';
import sample_bot from '../../img/intro/sample_bot.png';
import home_img_1 from '../../img/intro/home-img-1.svg';
import home_img_2 from '../../img/intro/home-img-2.svg';
import home_img_3 from '../../img/intro/home-img-3.svg';
import home_iphone from '../../img/intro/home-iphone.png';
import intro_img_1 from '../../img/intro/intro-img-1.png';
import bot_mobile_header from '../../img/intro/bot-mobile-header.png';
import intro_mobile_1 from '../../img/intro/1.png';
import intro_mobile_2 from '../../img/intro/2.png';
import intro_mobile_3 from '../../img/intro/3.png';
import intro_mobile_4 from '../../img/intro/4.png';
import ReactGA from 'react-ga';
import Legal from './Legal';

function connectToSocket(
  storeBotData,
  receiveData,
  conversationId,
  watermark,
  setEmotion,
  activeGif
) {
  const requestWithConversationId = {
    url: `https://directline.botframework.com/v3/directline/conversations/${conversationId}?watermark=${watermark}`,
    contentType: 'application/json',
    headers: { authorization: `Bearer ${config.secret}` },
    method: 'get',
    responseType: 'json',
  };

  const requestWithNoConversationId = {
    url: 'https://directline.botframework.com/v3/directline/conversations',
    contentType: 'application/json',
    headers: { authorization: `Bearer ${config.secret}` },
    method: 'post',
    responseType: 'json',
  };

  const startConversation = (res) => {
    const conversationId = res.data.conversationId;
    const sessionToken = config.secret;
    // console.log('start conversation', conversationId, sessionToken);
    storeBotData({
      conversationId,
      sessionToken,
    });
    let socket = new WebSocket(res.data.streamUrl);

    localStorage.setItem('conversationId', res.data.conversationId);
    localStorage.setItem('sessionToken', config.secret);

    socket.onclose = () => {
      // console.log('socket close')
      socket = new WebSocket(res.data.streamUrl);
      // console.log('new socket launched')
    };
    socket.onmessage = (e) => {
      if (e.data) {
        setEmotion(JSON.parse(e.data), activeGif);
        receiveData(JSON.parse(e.data));
      }
    };
  };

  if (conversationId !== undefined) {
    // console.log('there is a conversationId:', conversationId);
    /*if already have a conversationId, check if it is working...*/
    axios(requestWithConversationId)
      .then((res) => {
        if (res.status === 201 || res.status === 200) {
          // console.log('request made with conversationId', res.data.conversationId, '=> status: ', res.status);
          /*if everything OK*/
          startConversation(res);
        } else {
          // console.error(res.status)
        }
      })
      .catch((err) => {
        // console.error("ERROR 🔥 🔥 🔥", err)
        // console.log('conversationId seems to be shit, let\'get another one');
        throw axios(requestWithNoConversationId)
          .then((res) => {
            /*if everything OK*/
            if (res.status === 201 || res.status === 200) {
              // console.log('there is now a conversationId', res.data.conversationId, 'status is: ', res.status);
              startConversation(res);
            }
          })
          .catch((err) => {
            // console.error('AGAIN 🔥 🔥', err)
          });
      })
      .catch((err) => {
        // console.error('init error caught 🔥', err);
        return undefined;
      });
  } else {
    // console.log('there is no conversationId');
    /*if no conversationId, grab one and start conversation*/
    axios(requestWithNoConversationId).then((res) => {
      /*if everything OK*/
      // console.log('res.status', res.status);
      if (res.status === 201 || res.status === 200) {
        // console.log('there is now a conversationId', res.data.conversationId, 'status is: ', res.status);
        startConversation(res);
      }
    });
  }
}

window.sendTracker = (conversion_page) => {
  try {
    window.adperfTracker.track({ ...window.adperftrackobj, conversion_page });
  } catch (err) {
    console.error('adperfTracker ', conversion_page, err);
  }
};

class App extends Component {
  constructor() {
    super();
    ReactGA.initialize('UA-116577900-1');
    ReactGA.pageview('intro');
    this.state = {
      alreadySeenIntro: false,
      forceIntro: false,
      width: window.innerWidth,
      height: window.innerHeight,
      lastTimeNextPage: new Date(),
      currentIntroPage: 0,
    };

    this.handleDotClicked = this.handleDotClicked.bind(this);
  }

  componentDidMount() {
    const {
      storeBotData,
      receiveData,
      conversationId,
      watermark,
      getIpAddress,
      setEmotion,
    } = this.props;
    connectToSocket(
      storeBotData,
      receiveData,
      conversationId,
      watermark,
      setEmotion
    );
    getIpAddress();
    this.scrollToBottom();

    /*------------------------------------*/
    /*CONVERSTATION START 2 SECONDS AFTER LOADING*/
    /*------------------------------------*/

    // if (this.props.messages.length === 0) {
    //     const params = {
    //         type: 'message',
    //         from: {
    //             id: this.props.userId,
    //             ipAddress: this.props.ipAddress
    //         },
    //     };
    //     const formatedMessage = { ...params, text: 'ISSOU' };

    //     let __this = this;
    //     setTimeout(function() {
    //         __this.props.sendMessage(localStorage.getItem('sessionToken'), formatedMessage, localStorage.getItem('conversationId'));
    //         console.log(localStorage.getItem('sessionToken'), localStorage.getItem('conversationId'));
    //     }, 2000)
    // }
    /*------------------------------------*/
    /*END CONVERSATION START*/
    /*------------------------------------*/

    window.addEventListener('resize', this.updateDimensions.bind(this));
    window.sendTracker(635);
  }

  handleDotClicked(e) {
    this.setState({ currentIntroPage: parseInt(e.target.dataset.dot, 10) });
  }
  handlePrevClick() {
    this.setState({
      currentIntroPage:
        this.state.currentIntroPage === 0 ? 0 : this.state.currentIntroPage - 1,
    });
  }

  handleNextClick() {
    if (this.state.currentIntroPage === 4) {
      this.skipIntro();
    } else {
      this.setState({ currentIntroPage: this.state.currentIntroPage + 1 });
    }
  }

  updateDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }

  componentDidUpdate(prevProps) {
    this.secondRow &&
      !this.state.secondRow &&
      this.setState({
        secondRow: {
          offsetHeight: this.secondRow.offsetHeight,
          offsetTop: this.secondRow.offsetTop,
        },
      });
    if (prevProps.messages.length !== this.props.messages.length) {
      this.scrollToBottom();
    }
  }

  scrollToBottom() {
    if (this.secondRow) {
      this.secondRow.scrollTop = this.secondRow.scrollHeight;
    }
  }

  skipIntro() {
    ReactGA.pageview('chat');
    this.setState({
      alreadySeenIntro: true,
      forceIntro: false,
    });
    this.forceUpdate();
    /*------------------------------------*/
    /*CONVERSTATION START WHEN BUTTON 'COMMENCER' CLICKED*/
    /*------------------------------------*/
    if (this.props.messages.length === 0) {
      const params = {
        type: 'message',
        from: {
          id: this.props.userId,
          ipAddress: this.props.ipAddress,
        },
      };
      const formatedMessage = { ...params, text: 'ISSOU' };

      this.props.sendMessage(
        localStorage.getItem('sessionToken'),
        formatedMessage,
        localStorage.getItem('conversationId')
      );
      // console.log(localStorage.getItem('sessionToken'), localStorage.getItem('conversationId'));
      window.sendTracker(636);
    }
    /*------------------------------------*/
    /*END CONVERSATION START*/
    /*------------------------------------*/
  }

  startChat() {
    this.setState({ alreadySeenIntro: false, forceIntro: false }, () => {
      this.forceUpdate();
    });
    document.location.pathName = '?userMessage=Bonjour';
  }

  render() {
    const {
      activeGif,
      messages,
      conversationId,
      sessionToken,
      sendMessage,
      activeQuickReply,
      isBotTyping,
      isFetchingIpAddress,
      userId,
      ipAddress,
    } = this.props;

    if (
      window.location.href.match(/http:/) &&
      !window.location.href.match(/local/)
    ) {
      window.location.href = window.location.href.replace(/^http:/, 'https:');
    }

    if (this.state.alreadySeenIntro === false) {
      const page = this.state.currentIntroPage;
      return (
        <div>
          <div
            className="intro-mobile"
            style={
              this.state.width < 1000
                ? { display: 'flex', height: this.state.height }
                : { display: 'none' }
            }>
            <Legal layout="intro mobile" />
            <Swipe
              allowMouseEvents
              onSwipeRight={this.handlePrevClick.bind(this)}
              onSwipeLeft={
                page === 3
                  ? this.skipIntro.bind(this)
                  : this.handleNextClick.bind(this)
              }>
              <div
                className={`whole-page`}
                style={{
                  transform: `translate3d(calc(${page} * -100vw),0,0)`,
                }}>
                {/* PAGE 1 */}
                <div className={`page-content page-content-first-page `}>
                  <div
                    className="animated-background page-1-animated-background"
                    style={{ backgroundImage: `url(${intro_mobile_1})` }}></div>
                  <img
                    alt="no-description"
                    className="page-1-animated-picture"
                    src={intro_img_1}
                  />
                  <h2 className="page-1-title">Bot #LancezVous</h2>
                  <h3 className="page-1-subtitle">
                    Le chatbot qui vous aide à lancer
                    <br />
                    votre entreprise par{' '}
                    <img
                      alt="no-description"
                      src={bnp_horizontal_logo}
                      className="bnpparibas-logo"
                      style={{ position: 'relative', top: '5px' }}
                    />
                  </h3>
                  <div className="page-1-headline">
                    <span>Alors, prêt ? #lancezvous</span>
                  </div>
                </div>
                {/* PAGE 2 */}
                <div className={`page-content page-content-other-pages `}>
                  <div
                    className="animated-background page-2-animated-background"
                    style={{ backgroundImage: `url(${intro_mobile_2})` }}></div>
                  <div className="other-pages-step-title">ÉTAPE 01</div>
                  <div className="other-pages-step-description">
                    Trouver la bonne idée
                  </div>
                </div>
                {/* PAGE 3 */}
                <div className={`page-content page-content-other-pages `}>
                  <div
                    className="animated-background page-3-animated-background"
                    style={{ backgroundImage: `url(${intro_mobile_3})` }}></div>
                  <div className="other-pages-step-title">ÉTAPE 02</div>
                  <div className="other-pages-step-description">
                    Se poser les
                    <br /> bonnes questions
                  </div>
                </div>
                {/* PAGE 4 */}
                <div className={`page-content page-content-other-pages `}>
                  <div
                    className="animated-background page-4-animated-background"
                    style={{ backgroundImage: `url(${intro_mobile_4})` }}></div>
                  <div className="other-pages-step-title">ÉTAPE 03</div>
                  <div className="other-pages-step-description">
                    Construire le bon projet
                  </div>
                </div>
              </div>
            </Swipe>
            {/* CONTROLS */}
            <div className="page-controls">
              <div
                className={`page-controls-other-pages page-controls-specific ${
                  page > 0 ? 'in' : 'out'
                }`}>
                {page < 3 && (
                  <div
                    className="skip-introduction"
                    onClick={this.skipIntro.bind(this)}>
                    Passer l'introduction
                  </div>
                )}
                <div
                  id="prev-page-btn"
                  onClick={this.handlePrevClick.bind(this)}
                  className="intro-navigation-button">
                  Précedent
                </div>
                <div id="nav-dots">
                  <div
                    className={`nav-dot ${page === 1 ? 'active' : ''}`}
                    data-dot={1}
                    onClick={this.handleDotClicked}></div>
                  <div
                    className={`nav-dot ${page === 2 ? 'active' : ''}`}
                    data-dot={2}
                    onClick={this.handleDotClicked}></div>
                  <div
                    className={`nav-dot ${page === 3 ? 'active' : ''}`}
                    data-dot={3}
                    onClick={this.handleDotClicked}></div>
                </div>
                <div
                  id="next-page-btn"
                  onClick={
                    page === 3
                      ? this.skipIntro.bind(this)
                      : this.handleNextClick.bind(this)
                  }
                  className="intro-navigation-button">
                  {page < 3 ? 'Suivant' : 'Commencer'}
                </div>
              </div>
              <div
                className={`page-controls-first-page page-controls-specific ${
                  page === 0 ? 'in' : 'out'
                }`}>
                <button
                  className="page-controls-button"
                  onClick={this.handleNextClick.bind(this)}>
                  C'est parti
                </button>
              </div>
            </div>
          </div>

          <div
            className="intro-desktop"
            style={
              this.state.width >= 1000
                ? { display: 'block' }
                : { display: 'none' }
            }>
            <Legal layout="intro desktop" />
            {/* BACKGROUNDS */}
            <div className="background-wave-container">
              <div className="background-wave-left"></div>
              <div
                className="background-wave-center"
                style={{ backgroundImage: `url(${home_middle_bg})` }}></div>
              <div className="background-wave-right home-bg-3"></div>
            </div>
            <img
              alt="no-description"
              className="phone-example-bot"
              src={home_iphone}
            />
            {/* CONTENT */}
            <div className="intro-desktop-title">
              <h2>Bot #LancezVous</h2>
              <h3>
                Le chatbot qui vous aide à lancer
                <br />
                votre entreprise par{' '}
                <img
                  alt="no-description"
                  src={bnp_horizontal_logo}
                  style={{ position: 'relative', top: '5px' }}
                />
              </h3>
            </div>
            <div className="intro-desktop-description">
              <img
                alt="no-description"
                className="intro-desktop-description-bot-pic"
                src={sample_bot}
              />
              <div className="intro-desktop-description-text">
                <p>
                  Vous avez juste une idée ? Ou vous êtes déjà avancé dans votre
                  projet d'entreprise ? Vous souhaitez en évaluer la maturité ?
                  <br />
                  <strong>
                    Entraînez-vous avec le bot #LancezVous, le chatbot qui vous
                    aide à lancer votre entreprise !
                  </strong>
                  <br />
                  <br />
                  Sa mission : vous accompagner et vous préparer à bien
                  valoriser votre projet !
                  <br />
                  Au terme de cet entraînement, vous pourrez disposer d'un
                  bilan* et prendre contact* avec l'un des conseillers
                  professionnels de BNP Paribas qui mettra tout en oeuvre pour
                  faire aboutir votre projet.
                  <br />
                  <br />
                  <a
                    style={{ textDecoration: 'underline', color: 'inherit' }}
                    href="https://lancezvous.bnpparibas/protection-des-donnees"
                    target="_blank"
                    rel="noopener noreferrer">
                    En savoir plus sur les données personnelles
                  </a>
                  <br />
                  <br />
                  <strong>Alors, prêt ? #LancezVous</strong>
                </p>
                <button
                  className="intro-desktop-description-text-button"
                  onClick={this.skipIntro.bind(this)}>
                  COMMENCER
                </button>
              </div>
            </div>
            <div className="intro-desktop-animation">
              <svg className={`roadmap-line`} viewBox="0 0 1335 525">
                <path
                  className={`home-svg-path ${
                    navigator.userAgent.includes('Edge')
                      ? 'no-transition'
                      : 'no-edge'
                  }`}
                  fill="none"
                  fillRule="evenodd"
                  transform="translate(-589.000000, 0.000000)"
                  opacity="0.21"
                  d="M750.558119,0 L750.558119,83.5388621 C747.521238,127.303458 725.63894,149.185756 684.911225,149.185756 C623.819652,149.185756 590,155.790329 590,207.798817 C590,259.807304 654.663678,263.510144 702.610898,263.510144 C734.575712,263.510144 792.388767,263.510144 876.050063,263.510144 C932.469953,267.403667 960.679898,292.026453 960.679898,337.378501 C960.679898,382.73055 932.596882,406.941452 876.430852,410.011208 L691.073358,410.011208 C644.315067,407.196293 620.935922,426.492113 620.935922,467.898666 C620.935922,509.30522 654.865746,527.62181 722.725394,522.848438 L2531.80337,522.848438"
                  stroke="#6F6F6F"
                  strokeWidth="2"
                />
              </svg>
              <img
                alt="no-description"
                src={home_img_1}
                className="home-img home-img-1"
              />
              <img
                alt="no-description"
                src={home_img_2}
                className="home-img home-img-2"
              />
              <img
                alt="no-description"
                src={home_img_3}
                className="home-img home-img-3"
              />
              <div className="home-img-text home-img-1">
                Trouver la bonne idée
              </div>
              <div className="home-img-text home-img-2">
                Se poser les
                <br /> bonnes questions
              </div>
              <div className="home-img-text home-img-3">
                Construire le bon projet
              </div>
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div style={{ height: '100%', margin: '0' }}>
          {isFetchingIpAddress && (
            <div className="fullPage">
              <h3>{"Indentification de l'ordinateur"}</h3>
            </div>
          )}
          <Legal layout="chat desktop" />
          <Grid centered stackable style={{ height: '100%', margin: '0' }}>
            <Grid.Column
              id="inputUser"
              style={{
                backgroundColor: '#f8f7f9',
                width: '90%',
                height: '90vh',
                marginTop: '5vh',
                borderRadius: '10px',
                overflow: 'hidden',
                boxShadow: '0 7px 9px 0 rgba(0,0,0,0.14)',
              }}>
              <div style={{ height: '100%' }}>
                <Grid.Row
                  className="header-wrapper"
                  style={{
                    backgroundColor: 'white',
                    padding: '20px',
                    height: '120px',
                    boxShadow: '0 7px 9px 0 rgba(0, 0, 0, 0.05)',
                  }}>
                  <Grid.Column>
                    <div className="bot-character">
                      <Image
                        src={activeGif}
                        size="tiny"
                        className="gif-header"
                      />
                      <img
                        alt="no-description"
                        src={bot_mobile_header}
                        className="img-header-mobile"
                      />
                    </div>
                    <div className="bot-description">
                      <h2 className="title">Bot #LancezVous</h2>
                      <h3 className="subtitle">
                        <span>
                          Le chatbot dédié aux créateurs d’entreprise&nbsp;
                        </span>
                        <span>par BNP Paribas</span>
                      </h3>
                      {/*<p className="tagline">
                              Bonjour ! Je vous ai préparé un super entraînement pour pitcher votre projet ☺️
                          </p>*/}
                    </div>
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row
                  className="chat-container"
                  style={{
                    textAlign: 'center',
                    margin: 'auto',
                    height: 'calc(100% - 195px)',
                  }}>
                  <div
                    ref={(el) => {
                      this.secondRow = el;
                    }}
                    id="secondRow"
                    style={{ overflowY: 'scroll', height: '100%' }}>
                    <ChatHistory
                      messages={messages}
                      isBotTyping={isBotTyping}
                      sendMessage={sendMessage}
                      secondRow={this.state.secondRow}
                      conversationId={conversationId}
                      sessionToken={sessionToken}
                      userId={userId}
                      ipAddress={ipAddress}
                    />
                    {activeQuickReply && (
                      <QuickReplyBanner choices={activeQuickReply} />
                    )}
                    <br />
                  </div>
                </Grid.Row>
                <Grid.Row style={{ textAlign: 'center', margin: 'auto' }}>
                  <div
                    className="user-input-container"
                    style={{
                      backgroundColor: 'white',
                      padding: '10px',
                      width: '100%',
                    }}>
                    <UserInput
                      initialValues={{ sessionToken, conversationId }}
                      sendMessage={sendMessage}
                    />
                  </div>
                </Grid.Row>
                <Legal layout="chat mobile" />
              </div>
            </Grid.Column>
          </Grid>
          <ReduxToastr />
        </div>
      );
    }
  }
}

App.propTypes = {
  messages: PropTypes.array.isRequired,
  conversationId: PropTypes.string.isRequired,
  sessionToken: PropTypes.string.isRequired,
  sendMessage: PropTypes.func.isRequired,
  // activeQuickReply: PropTypes.object,
  // activeQuickReply: PropTypes.bool.isRequired,
  // watermark: PropTypes.number.isRequired,
  watermark: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
    .isRequired,
  isBotTyping: PropTypes.bool.isRequired,
  isFetchingIpAddress: PropTypes.bool.isRequired,
  activeGif: PropTypes.string.isRequired,
  userId: PropTypes.string.isRequired,
  ipAddress: PropTypes.string.isRequired,
};

const mapStateToProps = (state) => ({
  messages: getMessages(state),
  activeQuickReply: getActiveQuickReply(state),
  isBotTyping: isBotTyping(state),
  conversationId: state.global.get('config').toJS().conversationId,
  sessionToken: state.global.get('config').toJS().sessionToken,
  watermark: state.global.get('watermark'),
  isFetchingIpAddress: state.global.get('ip', Map({})).toJS().fetching,
  activeGif: activeGifSelector(state),
});

const ConnectedApp = connect(
  (state) => ({ userId: getUserId(state), ipAddress: getIpAddress(state) }),
  null
)(App);

export default connect(mapStateToProps, operations)(ConnectedApp);



// WEBPACK FOOTER //
// ./src/views/layouts/App.js